import type { ApiFailure } from "./shared/contracts";

export class ApiError extends Error {
  code: string;
  fieldErrors?: Record<string, string[]>;
  constructor(payload: ApiFailure["error"]) { super(payload.message); this.code = payload.code; this.fieldErrors = payload.fieldErrors; }
}

let csrfToken = sessionStorage.getItem("prt_csrf") ?? "";
export const setCsrfToken = (value: string) => { csrfToken = value; value ? sessionStorage.setItem("prt_csrf", value) : sessionStorage.removeItem("prt_csrf"); };

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const method = options.method ?? "GET";
  const headers = new Headers(options.headers);
  if (options.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  if (!["GET", "HEAD", "OPTIONS"].includes(method.toUpperCase()) && csrfToken) headers.set("X-CSRF-Token", csrfToken);
  const response = await fetch(path, { ...options, headers, credentials: "same-origin" });
  if (!response.ok) {
    const payload = await response.json() as ApiFailure;
    throw new ApiError(payload.error);
  }
  return response.json() as Promise<T>;
}

export const post = <T>(path: string, body?: unknown) => api<T>(path, { method: "POST", body: body === undefined ? undefined : JSON.stringify(body) });
export const patch = <T>(path: string, body: unknown) => api<T>(path, { method: "PATCH", body: JSON.stringify(body) });
